import useCompany from './useCompany'

interface UseCompanyPlatformAccess {
  readonly isLoading: boolean
  readonly isError: boolean
  readonly error: unknown
  readonly data: {
    readonly hasDeveloper: boolean
    readonly hasMonitor: boolean
    readonly hasServices: boolean
  }
}

export function useCompanyPlatformAccess(): UseCompanyPlatformAccess {
  const { isLoading, isError, error, data: company } = useCompany()

  return {
    isLoading,
    isError,
    error,
    data: {
      hasDeveloper: Boolean(company?.platforms.includes('esco')),
      hasMonitor: Boolean(company?.platforms.includes('monitor')),
      hasServices: Boolean(company?.platforms.includes('services'))
    }
  }
}
